import Context from "../app.context";
import { dispatcher, DispatcherEvents } from "../utils/dispatcher";
import serviceWorker from "../utils/serviceWorker";
import Notifications from "../utils/notifications";
import { DataActions } from "../store/data/actions";

const notificationKey = "service-worker";

export class ServiceWorkerEvents {
    private context: Context;
    private selfDestructTimeout: number;

    constructor(context: Context) {
        this.setContext(context);
    }

    setContext(context: Context) {
        this.context = context;
    }

    startWatching(): ServiceWorkerEvents {
        if (this.selfDestructTimeout) {
            clearTimeout(this.selfDestructTimeout);
        }
        /* eslint-disable @typescript-eslint/unbound-method */
        dispatcher.on(DispatcherEvents.ServiceWorkerInstallSuccess, this.onServiceWorkerInstallSuccess, this);
        dispatcher.on(DispatcherEvents.ServiceWorkerUpdateSuccess, this.onServiceWorkerUpdateSuccess, this);
        dispatcher.on(DispatcherEvents.ServiceWorkerUpdateFound, this.onServiceWorkerUpdateFound, this);
        dispatcher.on(DispatcherEvents.ServiceWorkerUpdateInstalling, this.onServiceWorkerUpdateInstalling, this);
        /* eslint-enable @typescript-eslint/unbound-method */
        return this;
    }

    stopWatching(): ServiceWorkerEvents {
        if (this.selfDestructTimeout) {
            clearTimeout(this.selfDestructTimeout);
        }
        /* eslint-disable @typescript-eslint/unbound-method */
        dispatcher.off(DispatcherEvents.ServiceWorkerUpdateInstalling, this.onServiceWorkerUpdateInstalling, this);
        dispatcher.off(DispatcherEvents.ServiceWorkerUpdateFound, this.onServiceWorkerUpdateFound, this);
        dispatcher.off(DispatcherEvents.ServiceWorkerUpdateSuccess, this.onServiceWorkerUpdateSuccess, this);
        dispatcher.off(DispatcherEvents.ServiceWorkerInstallSuccess, this.onServiceWorkerInstallSuccess, this);
        /* eslint-enable @typescript-eslint/unbound-method */
        return this;
    }

    private notify(message: string, action?: () => void) {
        if (this.context.user) {
            let user = this.context.userService.getUserByName(this.context.user);
            if (user) {
                Notifications.add(notificationKey, {
                    type: "app",
                    critical: false,
                    message,
                    action
                }, user.id);
            }
        }
    }

    private unNotify() {
        if (this.context.user) {
            let user = this.context.userService.getUserByName(this.context.user);
            if (user) {
                Notifications.remove(notificationKey, user.id);
            }
        }
    }

    private onServiceWorkerUpdateSuccess() {
        // TODO: Re-enable this if we need to better control app updates and prompt the user
        // let d = new Dialog("sw-update", "New app update. Install and reload now?", "Update Available", [
        //     {
        //         id: "sw-update-ok",
        //         text: "OK",
        //         callback: () => {
        //             serviceWorker.skipWaiting();
        //             d.remove();
        //         }
        //     }
        // ]);
        // d.open(this.context.translationService.getTranslator());
        this.context.store.dispatch(DataActions.setEnableSyncDelay(true));
        this.notify("App ready to update. Tap to update now.", () => {
            return serviceWorker.skipWaiting();
        });
    }

    private onServiceWorkerInstallSuccess() {
        this.notify("App is ready to use offline.");
        this.selfDestructTimeout = setTimeout(this.unNotify.bind(this), 10000);
    }

    private onServiceWorkerUpdateFound() {
        this.notify("App update found");
    }

    private onServiceWorkerUpdateInstalling() {
        this.notify("App update installing...");
    }
}